import env from "../common/environment.js";

class Sdk {
  // eslint-disable-next-line no-undef
  aes256SDK = new AlcheraAES256SDK(env.ENV_AES_RESOURCE_BASE_URL);
  // eslint-disable-next-line no-undef
  ocrSDK = new AlcheraOcrSDK();
  // eslint-disable-next-line no-undef
  faceSDK = new AlcheraFaceSDK(env.ENV_FACE_RESOURCE_BASE_URL);

  get face() {
    return this.faceSDK;
  }

  get ocr() {
    return this.ocrSDK;
  }

  get aes256() {
    return this.aes256SDK;
  }
}

const instance = new Sdk();
export default instance;
